/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./edit-version-drawer.vue?vue&type=template&id=430668ca&scoped=true&"
import script from "./edit-version-drawer.vue?vue&type=script&lang=ts&"
export * from "./edit-version-drawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430668ca",
  null
  
)

export default component.exports